import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_LINKS_CONFIG } from './cms-component-links.config';
import { NCmsComponentLinks } from './cms-component-links.interface';

@Component({
    selector: 'cms-component-links',
    templateUrl: './cms-component-links.component.html',
    styleUrl: './cms-component-links.component.scss',
    standalone: true,
    imports: [CommonModule, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentLinksComponent>(CMS_COMPONENT_LINKS_CONFIG)
export class CmsComponentLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentLinks.IData;
}
